angular.module('TurneroApp').component('coEncuestasPreguntas', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        'encuestasService',
        'utilsService',
        'TurneroAppConstant',
        function (encuestasService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.acciones = TurneroAppConstant.Acciones;
            ctrl.accion = null;
            ctrl.encuesta = {};
            ctrl.lstPreguntasOriginal = [];
            ctrl.lstPreguntasCombo = [];

            ctrl.errores = {
                Nombre: false,
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadPreguntas = function (pAccion, item) {
                    ctrl.encuesta = {};
                    ctrl.errores = {
                        Nombre: false,
                    };

                    ctrl.accion = pAccion;

                    if (ctrl.accion == ctrl.acciones.Crear) {
                        ctrl.promise = encuestasService.getConfiguracionBasica().$promise.then(function (res) {
                            ctrl.encuesta = res.Data;
                            ctrl.encuesta.Id_Centro_Atencion = ctrl.centroAtencionSeleccionado.id;
                            //ctrl.encuesta.Id_Encuesta = null;
                            ctrl.getComboPreguntas();
                        }).catch(function (req) {
                            utilsService.errores(req);
                            ctrl.ctrlPadre.cancelar();
                        });
                    }
                    else if (item && item.Id_Encuesta) {
                        ctrl.promise = encuestasService.getConfiguracionBasica({ 'id_encuesta': item.Id_Encuesta }).$promise.then(function (res) {
                            ctrl.encuesta = res.Data;
                            ctrl.getComboPreguntas();
                        }).catch(function (req) {
                            utilsService.errores(req);
                            ctrl.ctrlPadre.cancelar();
                        });
                    }
                }

                ctrl.ctrlPadre.guardarPreguntas = function () {
                    ctrl.errores.Nombre = !ctrl.encuesta.Nombre || ctrl.encuesta.Nombre.length < 3 || !utilsService.esAlfanumerico(ctrl.encuesta.Nombre);

                    for (let i in ctrl.errores) {
                        if (ctrl.errores[i])
                            return false;
                    }

                    utilsService.swalTitle('Procesando datos', 'info');

                    if (ctrl.accion == ctrl.acciones.Crear) {
                        encuestasService.postConfiguracionBasica({}, ctrl.encuesta).$promise.then(function (res) {
                            ctrl.encuesta.Id_Encuesta = res.Data;
                            ctrl.ctrlPadre.encuesta = ctrl.encuesta;
                            ctrl.ctrlPadre.nextTab();
                            swal.close();
                        }).catch(function (req) {
                            swal.close();
                            utilsService.errores(req);
                        });
                    }
                    else if (ctrl.accion == ctrl.acciones.Editar) {
                        encuestasService.putConfiguracionBasica(ctrl.encuesta).$promise.then(function (res) {
                            ctrl.ctrlPadre.nextTab();
                            swal.close();
                        }).catch(function (req) {
                            swal.close();
                            utilsService.errores(req);
                        });
                    }
                    else {
                        swal.close();
                    }

                    return true;
                }
            }

            ctrl.getComboPreguntas = function () {
                encuestasService.getComboPreguntas().$promise.then(function (res) {
                    ctrl.lstPreguntasOriginal = res.Data;
                    ctrl.actualizarCombo();
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            }

            ctrl.querySearch = function (query) {
                var results = query ? ctrl.lstPreguntasCombo.filter(ctrl.createFilterFor(utilsService.removeAccents(query))) : ctrl.lstPreguntasCombo;
                return results;
            }

            ctrl.createFilterFor = function (query) {
                var upperQuery = angular.uppercase(query);

                return function filterFn(item) {
                    let texto = utilsService.removeAccents(angular.uppercase(item.N_Opcion_Calificacion))
                    return (texto.indexOf(upperQuery) >= 0);
                };
            }

            ctrl.agregarPregunta = function (pregunta) {
                if (pregunta) {
                    //agrego la pregunta a la grilla
                    ctrl.encuesta.Preguntas.push(pregunta);

                    //filtro las preguntas del combo
                    ctrl.actualizarCombo();

                    //Limpio el combo
                    ctrl.preguntaSeleccionada = null;
                }
            }

            ctrl.eliminarPregunta = function (pregunta) {
                let i = ctrl.encuesta.Preguntas.findIndex(x => x.Id_Opcion_Calificacion == pregunta.Id_Opcion_Calificacion);

                if (i != -1) {
                    ctrl.encuesta.Preguntas.splice(i, 1);
                    ctrl.actualizarCombo();
                }
            }

            ctrl.actualizarCombo = function () {
                ctrl.lstPreguntasCombo = ctrl.lstPreguntasOriginal.filter(x => (ctrl.encuesta.Preguntas.findIndex(y => y.Id_Opcion_Calificacion == x.Id_Opcion_Calificacion) == -1));
            }
        }
    ],
    template: require('./encuestasPreguntas.html')
});


// WEBPACK FOOTER //
// ./app/components/supervision/encuestas/encuestasPreguntasComponent.js